<section class="pad" style="padding-top: 10px;">
    <div class="sedc contShadow sMbdrRad">

        <div style="padding:20px 50px">
            <h2>Travel Summary</h2>
            <hr>
            <br>
            <div class="flex" style="justify-content: start;padding-right: 30px;">
                <div class="detailsBox sMbdrRad" style="width:100%;">
                    <h1>Travel Details</h1>
                    <br>
                    <div class="flex">
                        <div class="flex fg" style="flex: 1;">
                            <div style="flex: 1;">
                                <p>Destination</p>
                                <h3>{{grossDetail['countryName']}}</h3>
                            </div>
                            <div style="flex: 1;">
                                <p>Package</p>
                                <h3>{{grossDetail['categoryName']}}</h3>
                            </div>

                        </div>

                        <div style="flex: 1;">
                            <!-- <h3 style="color: var(--secondary-color);">Duration of Cover</h3> -->
                            <div class="flex fg">
                                <div style="flex: 1;">
                                    <p>Start Date</p>
                                    <h3>{{grossDetail['startDate'] | date}}</h3>
                                </div>
                                <div style="flex: 1;">
                                    <p>End Date</p>
                                    <h3>{{grossDetail['endDate'] | date}}</h3>
                                </div>
                                <div style="flex:1; text-align: center;">
                                    <p>Number of Days:</p>
                                    <h3>{{grossDetail['numberOfDay'] | number}}</h3>
                                </div>
                            </div>

                        </div>
                        <!-- <div style="flex: 1;">

                            </div> -->
                    </div>
                </div>

            </div>
            <br>
            <div *ngIf="transaction && transaction['reconciled']==='Pending'" class="pending">This policy reconciliation is pending approval</div>
            <div *ngIf="transaction && transaction['reconciled']==='Confirmed'" class="confirmed">Reconciliation Confirmed</div>
            <div *ngIf="transaction && transaction['reconciled']==='Rejected'" class="rejected">Payment receipt was rejected.</div>
            <div *ngIf="transaction && transaction['reconciled']==='Rejected'" class="no-class">Rejection reason: {{transaction.auditTrail[0].reason}}</div>



            <div style="display: flex; justify-content: space-between; margin-right: 3em;">
                <h2 style="color: var(--secondary-color);padding-left: 10px;">Travellers</h2>
                <button *ngIf="transaction && transaction['reconciled']==='Confirmed'" color="warn" mat-stroked-button (click)="claim()">Log a Claim</button>
            </div>
            <br>
            <div class="wrapper">
                <div *ngFor="let person of persons">
                    <div class="detailsBox sMbdrRad">
                        <div class="flex" style="justify-content: end;">
                        </div>
                        <div class="flex" style="justify-content: space-between;">

                            <div>

                                <h3 style="color: var(--secondary-color);">{{person['firstname'] | titlecase}}
                                    {{person['othername'] | titlecase}} {{person['surname'] | titlecase}}</h3>
                            </div>
                            <div>
                                <a  [href]="person['certificate_url']" color="accent" *ngIf="person['certificate_url']" target="_blank"
                                    mat-stroked-button>View Certificate</a>
                                <button *ngIf="!(person['certificate_url']) && (grossDetail['transactionStatus'] == 'paid')" color="warn" (click)="retrigerCertificate(person['policy_detail_id'])"
                                    mat-stroked-button>Retry Certificate</button>
                                
                                <!-- <button mat-stroked-button (click)="viewCert(person['certificate_url'])">View Certificate</button> -->
                            </div>
                        </div>
                        <br>
                        <div class="flex fg">
                            <div style="flex: 1;">
                                <p>Phone No.</p>
                                <h3>{{person['phone']}}</h3>
                            </div>
                            <div style="flex: 1;">
                                <p>Email</p>
                                <h3>{{person['email'] | titlecase}}</h3>
                            </div>

                        </div>
                        <br>
                        <div>
                            <div class="flex fg">
                                <div style="flex: 1;">
                                    <p>Gender</p>
                                    <h3>{{person['gender']}}</h3>

                                </div>
                                <div style="flex: 1;">
                                    <p>DOB</p>
                                    <h3>{{person['dob'] | date}}</h3>
                                </div>
                            </div>

                        </div>
                        <br>
                        <div>
                            <div class="flex fg">
                                <div style="flex: 1;"> s
                                    <p>Premium</p>
                                    <h3>{{person['premium'] | currency:'₦ '}}</h3>

                                </div>
                                <div style="flex: 1;">
                                    <p>Passport Number</p>
                                    <h3>{{person['passportNo']}}</h3>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div>
                            <div class="flex fg">
                                <div style="flex: 1;">
                                    <p>Passport Issue Date</p>
                                    <h3>{{person['passportIssueDate'] | date}}</h3>

                                </div>
                                <div style="flex: 1;">
                                    <p>Passport Expiry Date</p>
                                    <h3>{{person['passportExpiryDate'] | date}}</h3>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div>
                            <div class="flex fg">
                                <div style="flex: 1;">
                                    <a href="{{person['passportDataPage']}}" target="_blank">
                                        <button class="passportBtn">
                                            View Passport Data Page
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <br>
                        <div>
                            <div class="flex fg">
                                <div *ngIf="person['certificate_url']"  style="flex: 1;">
                                    <p>Policy NO:</p>
                                    <h3>{{person['policyNo']}}</h3>
                                </div>
                            </div>

                        </div>
                        <div class="flex" style="justify-content: end;">
                        <a [routerLink]="'/main/request-edit/' + person['policyNo']" mat-mini-fab
                                    color="accent" *ngIf="person['policyNo']"
                                    matTooltip="Edit Certificate"><mat-icon style="color: white;">edit</mat-icon></a>
                                </div>

                    </div>
                </div>
            </div>
            <br>
            <div>
                <div>
                    <div>
                        <div class="flex">
                            <div style="flex:1;">
                                <p>Gross Premium</p>
                                <h3>{{grossDetail['grossPremium'] | currency:'₦ '}}</h3>
                            </div>
                            <div style="flex:1;">
                                <p>Net Premium</p>
                                <h3>{{(calcNet(grossDetail['grossPremium'])) | currency:'₦ '}}</h3>
                            </div>
                            <div style="flex:1;">
                                <p>Percentage</p>
                                <h3>20%</h3>
                            </div>
                            <div style="flex:1;">
                                <p>Commission</p>
                                <h3>{{calcCommission(grossDetail['grossPremium']) | currency:'₦ ' }}</h3>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <br>
            <div *ngIf="show" class="flex pad" style="justify-content: end; gap: 1rem;">

                <a mat-button mat-raised-button routerLink="/main/create-policy/{{id}}"
                    style="color: #fff; font-weight: bold;">Edit</a>
                <a mat-button mat-raised-button (click)="makePyt()" style="color: #fff; font-weight: bold;">Proceed to
                    Pay</a>
                <!-- <button ></button> -->
            </div>
        </div>
    </div>
</section>